import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Users, FileText, CheckCircle, Clock, ShieldAlert, AlertTriangle } from 'lucide-react';
import { KPICard } from '../components/KPICard';
import { StatusBadge } from '../components/StatusBadge';
import { UrgencyBadge } from '../components/UrgencyBadge';
import { Button } from '../components/Button';
import { useNavigate } from 'react-router-dom';
import { BINDA_LIST } from '../data/binda';
import { useStore } from '../data/store';
import { FilterBar, FilterField } from '../components/FilterBar';
import { Filter } from 'lucide-react';
import { SyncButton } from '../components/SyncButton';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/Select';
export default function WakilKepalaBindaDashboard() {
  const navigate = useNavigate();
  const reportsList = useStore(s => s.reports);
  const alertsList = useStore(s => s.alerts);
  // Wilayah BINDA aktif (dapat diganti via pemilih wilayah).
  const [regionKode, setRegionKode] = useState(BINDA_LIST.find(b => b.provinsi === 'Jawa Barat')!.kode);
  const regionData = BINDA_LIST.find(b => b.kode === regionKode) || BINDA_LIST.find(b => b.provinsi === 'Jawa Barat')!;
  const [showFilters, setShowFilters] = useState(false);
  const [filterValues, setFilterValues] = useState<Record<string, any>>({});
  const handleFilterChange = (key: string, value: any) => {
    setFilterValues(prev => ({
      ...prev,
      [key]: value
    }));
  };
  const handleResetFilters = () => {
    setFilterValues({});
  };
  const filterFields: FilterField[] = [{
    key: 'date',
    label: 'Periode Waktu',
    type: 'datePreset'
  }, {
    key: 'status',
    label: 'Status Laporan',
    type: 'statusBadge',
    options: [{
      label: 'Selesai',
      value: 'Selesai'
    }, {
      label: 'Tertunda',
      value: 'Tertunda'
    }]
  }];
  const regionalReports = reportsList.filter(r => r.region === regionData.provinsi);
  const regionalAlerts = alertsList.filter(a => a.location === regionData.provinsi);
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-4189">
      <div className="flex justify-between items-end border-b border-border/50 pb-4" data-id="element-4190">
        <div data-id="element-4191">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground uppercase" data-id="element-4192">
            PEMANTAUAN REGIONAL: {regionData.provinsi}
          </h1>
          <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-4193">
            {regionData.binda} // Tinjauan Wakil Kepala // Tinjauan Wakil Kepala
            // Tinjauan Wakil Kepala // Tinjauan Wakil Kepala // Tinjauan Wakil
            Kepala // Tinjauan Wakil Kepala
          </p>
        </div>
        <div className="flex gap-3 items-center" data-id="element-4194">
          <Select value={regionData.kode} onValueChange={setRegionKode} data-id="element-4195">
            <SelectTrigger size="sm" className="w-[220px] font-mono text-xs" data-id="element-4196">
              <SelectValue placeholder="Pilih Wilayah / BINDA" data-id="element-4197" />
            </SelectTrigger>
            <SelectContent data-id="element-4198">
              {[...BINDA_LIST].sort((a, b) => a.provinsi.localeCompare(b.provinsi)).map(b => <SelectItem key={b.kode} value={b.kode} data-id="element-4199">
                    {b.provinsi}
                  </SelectItem>)}
            </SelectContent>
          </Select>
          <Button variant={showFilters ? 'default' : 'outline'} size="sm" onClick={() => setShowFilters(!showFilters)} className={`h-8 border-border/50 font-mono text-xs ${showFilters ? 'bg-primary text-primary-foreground' : 'bg-background/50'}`} data-id="element-4200">
            <Filter className="w-4 h-4 mr-2" data-id="element-4201" />
            Filter
          </Button>
          <SyncButton data-id="element-4202" />
          <StatusBadge status={regionData.status} className="text-xs px-3 py-1.5" showDot data-id="element-4203" />
        </div>
      </div>

      {showFilters && <FilterBar fields={filterFields} values={filterValues} onChange={handleFilterChange} onApply={() => {}} onReset={handleResetFilters} data-id="element-4204" />}

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4" data-id="element-4205">
        <KPICard title="Total Operatif" value={regionData.personelAktif} icon={Users} colorVar="var(--primary)" trend={{
        value: 'SIAP DITUGASKAN',
        label: '',
        isPositive: true
      }} data-id="element-4206" />
        <KPICard title="Laporan Hari Ini" value={regionData.laporanHariIni} icon={FileText} colorVar="var(--status-info)" trend={{
        value: `${regionData.laporanPrioritas}`,
        label: 'PRIORITAS',
        isPositive: false
      }} data-id="element-4207" />
        <KPICard title="Tingkat Validasi" value={`${regionData.kpiWilayah}%`} icon={CheckCircle} colorVar="var(--status-active)" progress={{
        value: regionData.kpiWilayah,
        label: 'Target: 85%',
        target: '85%'
      }} data-id="element-4208" />
        <KPICard title="Rata-rata Respon" value="15m" icon={Clock} colorVar="var(--muted-foreground)" data-id="element-4209" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-4210">
        {/* Priority Reports */}
        <Card className="glass-panel border-border/50 flex flex-col overflow-hidden" data-id="element-4211">
          <CardHeader className="p-4 border-b border-border/50 bg-card/50 flex flex-row items-center justify-between shrink-0" data-id="element-4212">
            <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-4213">
              <ShieldAlert className="w-4 h-4 text-destructive" data-id="element-4214" /> Laporan
              Prioritas Wilayah
            </CardTitle>
            <Button variant="ghost" size="sm" className="text-[10px] font-mono" onClick={() => navigate('/reports')} data-id="element-4215">
              Lihat Semua
            </Button>
          </CardHeader>
          <CardContent className="p-0 flex-1 overflow-auto" data-id="element-4216">
            <div className="divide-y divide-border/50" data-id="element-4217">
              {regionalReports.length > 0 ? regionalReports.map(report => <div key={report.id} className="p-4 hover:bg-secondary/30 transition-colors cursor-pointer" onClick={() => navigate(`/reports/${report.id}`)} data-id="element-4218">
                    <div className="flex justify-between items-start mb-2" data-id="element-4219">
                      <span className="font-mono text-xs text-primary" data-id="element-4220">
                        {report.id}
                      </span>
                      <UrgencyBadge urgency={report.urgency} data-id="element-4221" />
                    </div>
                    <div className="font-heading font-semibold text-sm mb-2" data-id="element-4222">
                      {report.title}
                    </div>
                    <div className="flex justify-between items-center text-[10px] font-mono text-muted-foreground" data-id="element-4223">
                      <StatusBadge status={report.status} data-id="element-4224" />
                      <span data-id="element-4225">{report.time.split(' ')[1]}</span>
                    </div>
                  </div>) : <div className="p-8 text-center text-muted-foreground font-mono text-xs" data-id="element-4226">
                  Tidak ada laporan prioritas di wilayah ini.
                </div>}
            </div>
          </CardContent>
        </Card>

        {/* Active Alerts */}
        <Card className="glass-panel border-border/50 flex flex-col overflow-hidden" data-id="element-4227">
          <CardHeader className="p-4 border-b border-border/50 bg-card/50 flex flex-row items-center justify-between shrink-0" data-id="element-4228">
            <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-4229">
              <AlertTriangle className="w-4 h-4 text-[var(--status-standby)]" data-id="element-4230" />{' '}
              Peringatan Aktif
            </CardTitle>
            <Button variant="ghost" size="sm" className="text-[10px] font-mono" onClick={() => navigate('/alerts')} data-id="element-4231">
              Lihat Semua
            </Button>
          </CardHeader>
          <CardContent className="p-0 flex-1 overflow-auto" data-id="element-4232">
            <div className="divide-y divide-border/50" data-id="element-4233">
              {regionalAlerts.length > 0 ? regionalAlerts.map(alert => <div key={alert.id} className="p-4 hover:bg-secondary/30 transition-colors cursor-pointer" onClick={() => navigate(`/alerts/${alert.id}`)} data-id="element-4234">
                    <div className="flex justify-between items-start mb-2" data-id="element-4235">
                      <UrgencyBadge urgency={alert.type} data-id="element-4236" />
                      <span className="text-[10px] font-mono text-muted-foreground" data-id="element-4237">
                        {alert.time}
                      </span>
                    </div>
                    <div className="font-mono text-sm mb-2 text-foreground/90" data-id="element-4238">
                      {alert.desc}
                    </div>
                    <div className="text-[10px] font-mono text-muted-foreground uppercase" data-id="element-4239">
                      Sumber:{' '}
                      <span className="text-primary" data-id="element-4240">{alert.source}</span>
                    </div>
                  </div>) : <div className="p-8 text-center text-muted-foreground font-mono text-xs" data-id="element-4241">
                  Tidak ada peringatan aktif di wilayah ini.
                </div>}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}